import apiClient from "./client";

const VISITOR_ID_STORAGE_KEY = "mcverse-visitor-id";

function createVisitorId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `v-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
}

function getVisitorId() {
  if (typeof window === "undefined" || typeof localStorage === "undefined") return null;
  let existing = localStorage.getItem(VISITOR_ID_STORAGE_KEY);
  if (existing) return existing;
  existing = createVisitorId();
  localStorage.setItem(VISITOR_ID_STORAGE_KEY, existing);
  return existing;
}

export function trackEvents(events) {
  if (typeof navigator !== "undefined" && navigator.userAgent?.includes("ReactSnap")) {
    return Promise.resolve();
  }
  const visitorId = getVisitorId();
  const hydratedEvents = Array.isArray(events)
    ? events.map((event) => ({
        ...event,
        metadata: {
          ...(event?.metadata || {}),
          ...(visitorId ? { visitorId } : {}),
        },
      }))
    : events;
  return apiClient.post("/analytics/events", { events: hydratedEvents }).catch(() => {});
}
